<template>
    <div
        class="down house-item fix-clear dl-house-item"
        :class="{ 'no-border': !hasBorder }"
        v-data-npv="data.clickSoj"
        @click="openMiniProgram"
    >
        <div class="dl-house-item-wrap">
            <div class="house-img-wrap">
                <img src="//pages.anjukestatic.com/usersite/touch/img/appdownload/esf.png" alt="" class="house-img" />
            </div>
            <div class="down-intro">
                <div class="down-title down-intro-item">{{ data.month + '月' + data.cityName }}优惠房源</div>
                <div class="down-desc down-intro-item">实时更新</div>
                <div class="down-desc down-intro-item">尽在安居客小程序</div>
            </div>

            <div class="down-button">打开小程序</div>
        </div>
    </div>
</template>

<script>
export default {
    inject: ['ENV'],
    name: 'promotionRecommend',
    props: {
        data: {
            required: true,
            type: Object
        },
        hasBorder: {
            type: Boolean,
            default: true
        },
        miniProgramType: {
            type: String,
            default: 'esf'
        }
    },
    methods: {
        openMiniProgram() {
            const appid = this.ENV === 'wuba' ? 'wx1658c7eccb8126e7' : 'wx099e0647f9a4717d';
            const path =
                this.miniProgramType === 'xf' ? 'page/xf/pages/home/list' : 'page/taroPage/esf/pages/list/list';
            const baseUrl = `weixin://dl/business/?appid=${appid}&path=${path}`;
            window.location.href = baseUrl;
        }
    }
};
</script>

<style scoped lang="scss" src="./index.scss"></style>
<style scoped lang="scss">
.dl-house-item {
    display: block;
    padding-bottom: 6px !important;
}
.dl-house-item-wrap {
    display: -webkit-box;
}
.house-item.down {
    padding-right: 15px;
    padding-bottom: 15px;
    .down-button {
        right: 15px;
    }
}
</style>
